<template>
  <div class="page-header" style="background-color: #252525">
    <div class="">
      <div class="container">
        <div slot="header" class="logo-container mb-4">
          <img
            v-lazy="'img/icons/LogoTrivia.png'"
            alt="LogoTrivia "
            class="img-logo-trivia"
          />
        </div>
        <div class="col-md-5 ml-auto mr-auto">
          <card type="login" plain>
            <div class="spinner-grow text-success" role="status" v-if="show">
              <span class="sr-only">Loading...</span>
            </div>

            <div v-else>
              <Alert type="warning" v-if="statusAlert">{{ msjError }}</Alert>
              <label for="Nombre">
                ingrese sus datos para comenzar el juego
              </label>
              <fg-input
                id="Nombre"
                class="no-border input-lg"
                addon-left-icon="now-ui-icons users_circle-08"
                placeholder="Nombre completo"
                v-model="nombre"
                required
              >
              </fg-input>
              <fg-input
                id="Dni"
                class="no-border input-lg"
                addon-left-icon="now-ui-icons users_circle-08"
                placeholder="DNI (sin puntos)"
                v-model="dni"
                maxlength="8"
                required
                @input="dni = dni.replace(/\D/g, '')"
              >
              </fg-input>
              <fg-input
                class="no-border input-lg"
                addon-left-icon="now-ui-icons ui-1_email-85"
                placeholder="Email"
                type="email"
                v-model="email"
                required
              >
              </fg-input>
              <fg-input
                class="no-border input-lg"
                addon-left-icon="now-ui-icons ui-1_email-85"
                 placeholder="Ej.: +54 9 3863 123456"
                type="text"
                v-model="phone"
                required
              >
              </fg-input>
            </div>
            <template v-if="!show" slot="raw-content">
              <div class="card-footer text-center">
                <a
                  class="btn btn-primary btn-round btn-lg btn-block"
                  style="background-color: #76bc21"
                  @click="sendDataUser"
                  >Jugar</a
                >
              </div>
            </template>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Card, FormGroupInput, Alert } from "@/components";
import config from "../../../../config";

export default {
  name: "login-page",
  bodyClass: "login-page",

  components: {
    Card,
    [FormGroupInput.name]: FormGroupInput,
    Alert,
  },

  data() {
    return {
      nombre: "",
      email: "",
      dni: "",
      phone: "",
      statusAlert: false,
      show: false,
      msjError: "",
      url:
        process.env.NODE_ENV === "development"
          ? config.developmentUrl
          : config.productionUrl,
    };
  },
  mounted() {},
  methods: {
    showError(msg) {
      this.msjError = msg;
      this.statusAlert = true;

      setTimeout(() => {
        this.statusAlert = false;
      }, 3000);
    },
    validateDni(dni) {
      const regex = /^[0-9]{7,8}$/;
      return regex.test(dni);
    },
    sendDataUser() {
      if (!this.nombre.trim() || !this.email.trim() || !this.dni.trim() || !this.phone.trim()) {
        return this.showError("Todos los campos son obligatorios");
      }
      if (!this.validateEmail(this.email)) {
        return this.showError(
          'Ingresa un correo válido, ej: "nombre@ejemplo.com"'
        );
      }
      if (!this.validateDni(this.dni)) {
        return this.showError("El DNI debe tener entre 7 y 8 números");
      }
      this.show = true;
      const data = {
        name: this.nombre.trim(),
        email: this.email.trim(),
        dni: this.dni,
        phone: this.phone.trim(),
      };
      fetch(`${this.url}api/trivia/loginPlayer`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((result) => {
          if (result.status == 409 || result.status == 500) {
            return this.showError(result.error);
          }
          this.$emit("statusChange", result);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.show = false;
        });
    },
    validateEmail(email) {
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return regex.test(email);
    },
  },
};
</script>
<style scoped>
.iconAlquimia {
  border-radius: 20%;
}
.img-logo-trivia {
  padding: 50px;
}

/* imagen */

@media (max-width: 768px) {
  .contenedor-tabla {
    height: 400pt;
    overflow: scroll;
  }
  .img-logo-trivia {
    padding: 50px;
  }
}

@media (min-width: 768px) {
  .img-logo-trivia {
    width: 50%;
    height: 50%;
  }
}
</style>
